import { cn } from '../../lib/utils';
import { useTranslation } from '../../context/LanguageContext';
import type { Paper } from '../../types/wizard';
import { FileText } from 'lucide-react';

interface PaperCardProps {
  paper: Paper;
  isSelected: boolean;
  onSelect: (paper: Paper) => void;
}

export function PaperCard({ paper, isSelected, onSelect }: Readonly<PaperCardProps>) {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={() => onSelect(paper)}
      className={cn(
        'relative flex flex-col items-start gap-3 rounded-2xl border-2 p-5 text-left transition-all duration-200 hover:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 w-full',
        isSelected
          ? 'border-violet-500 bg-violet-500/10 shadow-md'
          : 'border-slate-700 bg-slate-700/50 hover:border-violet-400'
      )}
    >
      <div
        className={cn(
          'flex h-11 w-11 items-center justify-center rounded-xl',
          isSelected ? 'bg-violet-600 text-white' : 'bg-slate-700 text-slate-400'
        )}
      >
        <FileText className="h-5 w-5" />
      </div>
      <div>
        <p className="font-semibold text-white">{paper.name}</p>
        <p className="text-sm text-slate-500 mt-0.5">
          {t('wizard.paperChapters', { count: paper.chapters.length })}
        </p>
      </div>
      {isSelected && (
        <div className="absolute top-3 right-3 h-5 w-5 rounded-full bg-violet-600 flex items-center justify-center">
          <svg
            className="h-3 w-3 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={3}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        </div>
      )}
    </button>
  );
}
